<div class="flex-col">
    <h1 id="title">Report Interventions</h1>
    @if (this.loading) {
    <mat-spinner></mat-spinner>
    }
</div>
<div class="issue-tracker-container" [style.visibility]="loading? 'hidden': 'visible'">
    @if(showTable){
    <div class="flex-col" id="deviation-table">
        @if(noBugs) {
        <p id="no-bugs">Could not load any bugs. Please verify with ADO admins (Svitlana or Jorgen) that you have access
            to the project</p>
        }
        @else{
        <div
            style="width: 90%; display: flex; flex-direction: column; align-items: center; justify-content: center; margin: 20px;">
            <h2 id="subtitle"> Filter Deviations </h2>
            <div class="filters-container">
                <filter-list id="hw-filter" class="filter-list" (filterEmit)="addHwVersionFilter($event)" [filterName]="'HW Component'"
                    [dataSource]="dataSourceHwVersions">
                </filter-list>
                <filter-list id="issue-group-filter" class="filter-list" (filterEmit)="addIssueGroupFilter($event)" [filterName]="'Issue Group'"
                    [dataSource]="dataSourceIssueGroups">
                </filter-list>
            </div>
        </div>


        <h2 id="subtitle"> List of Deviations </h2>
        <div class="bug-list-container mat-elevation-z2">
            <mat-form-field>
                <mat-label>Search for keyword in title or description...</mat-label>
                <input id="search-filter" matInput (keyup)="applySearchFilter($event)"
                    placeholder="Ex. Lidar, RGo, Camera..." #input>
            </mat-form-field>



            <table mat-table [dataSource]="dataSource" matSortActive="numberOfReports" matSortDirection="desc" matSort
                multiTemplateDataRows>

                @for (column of propertiesToDisplay; track column) {
                <ng-container matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{propertyHeaderMap.get(column)}} </th>
                    <td mat-cell *matCellDef="let element"
                        (click)="expandedElement = expandedElement === element ? null : element" disabled>
                        {{element[column]}}
                    </td>
                </ng-container>
                }

                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button aria-label="expand row"
                            (click)="expandedElement = expandedElement === element ? null : element">
                            @if (expandedElement === element) {
                            <mat-icon>keyboard_arrow_up</mat-icon>
                            } @else {
                            <mat-icon>keyboard_arrow_down</mat-icon>
                            }
                        </button>
                    </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="propertiesToDisplayWithExpand.length">
                        <div class="expanded-bug"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <div class="bug-button-container">
                                @if (showAdoButton) {
                                <a [href]="'https://dev.azure.com/wheelme/' + adoProject + '/_workitems/edit/' + element.id"
                                    target="_blank">
                                    <button id="ado-button" mat-fab extended aria-label="Link to ADO ticket">
                                        <mat-icon>open_in_new</mat-icon>
                                        Open ticket in ADO
                                    </button>
                                </a>
                                }
                                <app-report-intervention-button [bug]="element" class="mat-elevation-z0"/>
                            </div>
                            <div [innerHTML]="element.description | getImageUrl | async">
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="propertiesToDisplayWithExpand"></tr>
                <tr mat-row *matRowDef="let element; columns: propertiesToDisplayWithExpand;" class="table-row"
                    [class.expanded-row]="expandedElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="bug-details"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of users"></mat-paginator>
        </div>
        }
    </div>
    }
    <h2 id="subtitle">
        Report intervention with no deviation
    </h2>
    <app-report-intervention-button />
</div>
